// Constants
import { LINE_EDGE_DND_TYPE, LINE_CONTROL_POINT_DND_TYPE } from '../../../common/lines/lineConstants';

export const isDraggingLineEdge = (itemType) => itemType === LINE_EDGE_DND_TYPE;
export const isDraggingLineControlPoint = (itemType) => itemType === LINE_CONTROL_POINT_DND_TYPE;
export const hasConnectingElementIds = (item) => item && item.connectingElementIds && item.connectingElementIds.length;

export const isLineAffectedByDrag = (item, itemType) =>
    isDraggingLineEdge(itemType) || hasConnectingElementIds(item) || isDraggingLineControlPoint(itemType);
